(ns hypnos.dme.tile.field.consult-mask
  "Field current mask used."
  (:require [hypnos.i18n :refer [tr]]
            [hypnos.lookup :refer
             (all-makes-by-manufacturer-id
              all-models-by-manufacturer-id-make-id)]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; helpers

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; field

(defn field
  ([state]
   (field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   (let [catalog (rf/subscribe [:dme/catalog])]
     [:div.field.is-horizontal
      [:div.field-label.is-normal
       [:label.label
        (if (= :service-type/new-setup (get-in @state [:patient :patient/last-consult :consult/service-type :value]))
          (tr :ui.label/study-mask)
          (tr :ui.label/current-mask))]]
      [:div.field-body
       ;; manufacturer
       [:div.field.is-narrow
        [:div.control
         [:div.select.is-fullwidth
          [:select
           {:type      :text
            :disabled  disabled
            :value     (if-let [val (get-in @state [:patient :patient/last-consult :consult/manufacturer :value])]
                         val
                         "")
            :on-change (fn [e]
                         (let [old-value (get-in @state [:patient :patient/last-consult :consult/manufacturer :value])
                               new-value (-> e .-target .-value)
                               new-value (when-not (= "" new-value)
                                           new-value)
                               changed?  (or (get-in @state [:patient :patient/last-consult :consult/manufacturer :dirty?])
                                             (not= new-value old-value))]
                           (swap! state assoc-in
                                  [:patient :patient/last-consult :consult/manufacturer :value]
                                  new-value)
                           (swap! state assoc-in
                                  [:patient :patient/last-consult :consult/manufacturer :dirty?]
                                  changed?)
                           (when changed?
                             (swap! state assoc-in
                                    [:patient :patient/last-consult :consult/make]
                                    {:value    nil
                                     :dirty?   false
                                     :touched? false})
                             (swap! state assoc-in
                                    [:patient :patient/last-consult :consult/model]
                                    {:value    nil
                                     :dirty?   false
                                     :touched? false}))))
            :on-focus  (fn [_]
                         (swap! state assoc-in
                                [:patient :patient/last-consult :consult/manufacturer :touched?]
                                true))}
           [:option {:value ""} ""]
           (doall
            (for [m (sort-by :manufacturer/name @catalog)]
              [:option {:key (:manufacturer/id m) :value (:manufacturer/id m)} (:manufacturer/name m)]))]]]
        [:p.help (tr :ui.help/manufacturer)]]
       ;; make
       [:div.field.is-narrow
        [:div.control
         [:div.select.is-fullwidth
          [:select
           {:type      :text
            :disabled  (or disabled
                           (nil? (get-in @state [:patient :patient/last-consult :consult/manufacturer :value])))
            :value     (if-let [val (get-in @state [:patient :patient/last-consult :consult/make :value])]
                         (name val)
                         "")
            :on-change (fn [e]
                         (let [old-value (get-in @state [:patient :patient/last-consult :consult/make :value])
                               new-value (-> e .-target .-value)
                               new-value (when-not (= "" new-value)
                                           new-value)
                               changed?  (or (get-in @state [:patient :patient/last-consult :consult/make :dirty?])
                                             (not= new-value old-value))]
                           (swap! state assoc-in
                                  [:patient :patient/last-consult :consult/make :value]
                                  new-value)
                           (swap! state assoc-in
                                  [:patient :patient/last-consult :consult/make :dirty?]
                                  changed?)
                           (when changed?
                             (swap! state assoc-in
                                    [:patient :patient/last-consult :consult/model]
                                    {:value    nil
                                     :dirty?   false
                                     :touched? false}))))
            :on-focus  (fn [_]
                         (swap! state assoc-in
                                [:patient :patient/last-consult :consult/make :touched?]
                                true))}
           [:option {:value ""} ""]
           (doall
            (for [make (sort-by :make/name
                                (all-makes-by-manufacturer-id @catalog
                                                              (get-in @state [:patient :patient/last-consult :consult/manufacturer :value])))]
              [:option {:key (:make/id make) :value (:make/id make)} (:make/name make)]))]]]
        [:p.help (tr :ui.help/mask)]]
       ;; model
       [:div.field.is-narrow
        [:div.control
         [:div.select.is-fullwidth
          [:select
           {:type      :text
            :disabled  (or disabled
                           (nil? (get-in @state [:patient :patient/last-consult :consult/manufacturer :value]))
                           (nil? (get-in @state [:patient :patient/last-consult :consult/make :value])))
            :value     (if-let [val (get-in @state [:patient :patient/last-consult :consult/model :value])]
                         (name val)
                         "unknown")
            :on-change (fn [e]
                         (let [old-value (get-in @state [:patient :patient/last-consult :consult/model :value])
                               new-value (-> e .-target .-value)
                               new-value (when-not (= "" new-value)
                                           new-value)
                               changed?  (or (get-in @state [:patient :patient/last-consult :consult/model :dirty?])
                                             (not= new-value old-value))]
                           (swap! state assoc-in
                                  [:patient :patient/last-consult :consult/model :value]
                                  new-value)
                           (swap! state assoc-in
                                  [:patient :patient/last-consult :consult/model :dirty?]
                                  changed?)))
            :on-focus  (fn [_]
                         (swap! state assoc-in
                                [:patient :patient/last-consult :consult/model :touched?]
                                true))}
           [:option {:value ""} ""]
           (doall
            (for [model (sort-by :model/name
                                 (all-models-by-manufacturer-id-make-id @catalog
                                                                        (get-in @state [:patient :patient/last-consult :consult/manufacturer :value])
                                                                        (get-in @state [:patient :patient/last-consult :consult/make :value])))]
              [:option {:key (:model/id model) :value (:model/id model)} (:model/name model)]))]]]
        [:p.help (tr :ui.help/size)]]]])))
